import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import routes from 'constants/routes';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { ABCSquares } from 'styles/assets/icons';

import styles from './styles.module.scss';

interface TryEasyOptionsButtonProps {
  mixpanelSource: string;
}
const TryEasyOptionsButton = (props: TryEasyOptionsButtonProps) => {
  const { mixpanelSource } = props;
  const { t } = useTranslation(['markets']);

  const handleClick = () => {
    trackMixpanelEvent('Easy Options Accessed', {
      source: mixpanelSource,
    });
  };

  return (
    <Link
      data-testid="TryEasyOptionsLink-Markets"
      to={routes.easy_options.trade}
      onClick={handleClick}
      className={styles.tryEasyOptionsButton}
    >
      <ABCSquares className={styles.abcSquaresIcon} />
      {t('markets:optionsTable.tryEasyOptions')}
    </Link>
  );
};

export default TryEasyOptionsButton;
